import { getReferrerPersonalInfo } from '../../../redux/api/referred';
import { createRefered } from '../../../redux/api/refered';
import { useEffect, useState } from 'react';

export const useGuest = (repoId) => {
    const [contact, setContact] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchContact = async () => {
            setLoading(true);
            try {
                const response = await getReferrerPersonalInfo(repoId);

                if (response.error) {
                    throw new Error(response.error);
                }
                setContact(response);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchContact();
    }, [repoId]);

    const submitGuestInformation = async (guestData) => {
        const response = await createRefered(guestData);
        return !response.error ? false : true;
    };

    return { contact, loading, error, submitGuestInformation };
};
